module.exports = __webpack_public_path__ + "img/34-Elasticity.b457f6d8.png";